<div class="container mx-auto px-0 py-0">
  <div class="bg-white shadow-md rounded-lg p-6">
    <!-- Header (aligned with client component) -->
    <div class="flex justify-between items-center mb-6">
      <div class="flex items-center space-x-2">
        <mat-icon class="w-6 h-6">settings</mat-icon>
        <h2 class="text-2xl font-bold mb-0 text-gray-900">Einstellungen</h2>
      </div>
      <div class="flex space-x-2">
        <!-- Top action buttons (optional) -->
        <button mat-stroked-button color="primary" (click)="saveGeneralSettings()">
          <mat-icon class="mr-2">save</mat-icon>
          Speichern
        </button>
      </div>
    </div>

    <!-- Settings Tabs -->
    <div>
      <mat-tab-group class="settings-tabs" animationDuration="300ms">
        
        <!-- Password Change Tab -->
        <mat-tab label="Passwort ändern">
          <div class="p-8">
            <div class="max-w-2xl">
              <div class="mb-6">
                <h2 class="text-2xl font-semibold text-gray-900 mb-2">Passwort ändern</h2>
                <p class="text-gray-600">Ändern Sie Ihr aktuelles Passwort für mehr Sicherheit</p>
              </div>

              <form [formGroup]="passwordForm" (ngSubmit)="changePassword()">
                <!-- Current Password -->
                <div class="form-group">
                  <label class="form-label" for="currentPassword">Aktuelles Passwort *</label>
                  <input
                    type="password"
                    class="form-control"
                    id="currentPassword"
                    formControlName="currentPassword"
                    placeholder="Geben Sie Ihr aktuelles Passwort ein"
                    class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    [class.is-invalid]="passwordForm.controls['currentPassword'].invalid && passwordForm.controls['currentPassword'].touched" />
                  <div *ngIf="passwordForm.controls['currentPassword'].invalid && passwordForm.controls['currentPassword'].touched" class="text-red-500 text-sm mt-1">
                    Aktuelles Passwort ist erforderlich
                  </div>
                </div>

                <!-- New Password -->
                <div class="form-group">
                  <label class="form-label" for="newPassword">Neues Passwort *</label>
                  <input
                    type="password"
                    class="form-control"
                    id="newPassword"
                    formControlName="newPassword"
                    placeholder="Geben Sie Ihr neues Passwort ein"
                    class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    [class.is-invalid]="passwordForm.controls['newPassword'].invalid && passwordForm.controls['newPassword'].touched" />
                  <div *ngIf="passwordForm.controls['newPassword'].invalid && passwordForm.controls['newPassword'].touched" class="text-red-500 text-sm mt-1">
                    Neues Passwort ist erforderlich (mindestens 8 Zeichen)
                  </div>
                </div>

                <!-- Confirm Password -->
                <div class="form-group">
                  <label class="form-label" for="confirmPassword">Passwort bestätigen *</label>
                  <input
                    type="password"
                    class="form-control"
                    id="confirmPassword"
                    formControlName="confirmPassword"
                    placeholder="Bestätigen Sie Ihr neues Passwort"
                    class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    [class.is-invalid]="passwordForm.controls['confirmPassword'].invalid && passwordForm.controls['confirmPassword'].touched" />
                  <div *ngIf="passwordForm.controls['confirmPassword'].invalid && passwordForm.controls['confirmPassword'].touched" class="text-red-500 text-sm mt-1">
                    Passwort-Bestätigung stimmt nicht überein
                  </div>
                </div>

                <!-- Password Requirements -->
                <div class="bg-blue-50 p-4 rounded-lg">
                  <h3 class="text-sm font-semibold text-blue-800 mb-2">Passwort-Anforderungen:</h3>
                  <ul class="text-sm text-blue-700 space-y-1">
                    <li>• Mindestens 8 Zeichen lang</li>
                    <li>• Enthält Groß- und Kleinbuchstaben</li>
                    <li>• Enthält mindestens eine Zahl</li>
                    <li>• Enthält mindestens ein Sonderzeichen</li>
                  </ul>
                </div>

                <!-- Submit Button -->
                <div class="form-group">
                  <button
                    type="submit"
                    [disabled]="passwordForm.invalid"
                    class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg flex items-center">
                    <mat-icon class="mr-2">lock</mat-icon>
                    Passwort ändern
                  </button>
                </div>
              </form>
              </div>
            </div>
          </mat-tab>

        <!-- Profile Image Tab -->
        <mat-tab label="Profilbild">
          <div class="p-8">
            <div class="max-w-2xl">
              <div class="mb-6">
                <h2 class="text-2xl font-semibold text-gray-900 mb-2">Profilbild verwalten</h2>
                <p class="text-gray-600">Laden Sie ein neues Profilbild hoch oder ändern Sie das aktuelle</p>
              </div>

              <div class="space-y-6">
                <!-- Current Profile Image -->
                <div class="flex items-center space-x-6">
                  <div class="flex-shrink-0">
                    <div class="w-24 h-24 bg-gray-200 rounded-full flex items-center justify-center overflow-hidden">
                      <img 
                        *ngIf="profileImageUrl; else noImageTemplate"
                        [src]="profileImageUrl" 
                        alt="Profilbild" 
                        class="w-full h-full object-cover">
                      <ng-template #noImageTemplate>
                        <svg class="w-12 h-12 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd"></path>
                        </svg>
                      </ng-template>
                    </div>
                  </div>
                  <div>
                    <h3 class="text-lg font-medium text-gray-900">Aktuelles Profilbild</h3>
                    <p class="text-sm text-gray-500">Maximale Größe: 2MB</p>
                    <p class="text-sm text-gray-500">Unterstützte Formate: JPG, PNG, GIF</p>
                  </div>
                </div>

                <!-- Upload Form -->
                <form (ngSubmit)="uploadProfileImage()" enctype="multipart/form-data" class="space-y-4">
                  <div>
                    <label for="profileImage" class="block text-sm font-medium text-gray-700 mb-2">Neues Profilbild auswählen</label>
                          <input
                      type="file"
                      id="profileImage"
                      accept="image/*"
                      (change)="onFileSelected($event)"
                      class="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100">
                  </div>

                  <div *ngIf="selectedFile" class="bg-green-50 p-4 rounded-lg">
                    <div class="flex items-center">
                      <svg class="w-5 h-5 text-green-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
                      </svg>
                      <span class="text-sm text-green-700">{{ selectedFile.name }} ausgewählt</span>
                    </div>
                  </div>

                  <div class="flex space-x-4">
                    <button
                      mat-raised-button
                      color="primary"
                      type="submit"
                      [disabled]="!selectedFile"
                      class="px-6 py-2">
                      <mat-icon class="mr-2">cloud_upload</mat-icon>
                      Hochladen
                    </button>
                    
                    <button
                      mat-button
                      type="button"
                      (click)="removeProfileImage()"
                      class="px-6 py-2 text-red-600">
                      <mat-icon class="mr-2">delete</mat-icon>
                      Bild entfernen
                    </button>
                  </div>
                  </form>
              </div>
              </div>
            </div>
          </mat-tab>

        <!-- General Settings Tab -->
        <mat-tab label="Allgemeine Einstellungen">
          <div class="p-8">
            <div class="max-w-4xl">
              <div class="mb-6">
                <h2 class="text-2xl font-semibold text-gray-900 mb-2">Allgemeine Einstellungen</h2>
                <p class="text-gray-600">Passen Sie die Anwendung an Ihre Bedürfnisse an</p>
              </div>

              <form [formGroup]="generalSettingsForm" (ngSubmit)="saveGeneralSettings()" class="space-y-8">
                <!-- Notification Settings -->
                <div class="bg-white border border-gray-200 rounded-lg p-6">
                  <h3 class="text-lg font-semibold text-gray-900 mb-4">Benachrichtigungen</h3>
                  <div class="space-y-4">
                    <div class="flex items-center justify-between">
                      <div>
                        <h4 class="text-sm font-medium text-gray-900">E-Mail Benachrichtigungen</h4>
                        <p class="text-sm text-gray-500">Erhalten Sie wichtige Updates per E-Mail</p>
                      </div>
                      <mat-slide-toggle formControlName="emailNotifications" color="primary"></mat-slide-toggle>
                    </div>
                    
                    <div class="flex items-center justify-between">
                      <div>
                        <h4 class="text-sm font-medium text-gray-900">Push-Benachrichtigungen</h4>
                        <p class="text-sm text-gray-500">Erhalten Sie sofortige Benachrichtigungen im Browser</p>
                      </div>
                      <mat-slide-toggle formControlName="pushNotifications" color="primary"></mat-slide-toggle>
                    </div>

                    <div class="flex items-center justify-between">
                      <div>
                        <h4 class="text-sm font-medium text-gray-900">Wöchentliche Zusammenfassung</h4>
                        <p class="text-sm text-gray-500">Erhalten Sie eine wöchentliche Übersicht Ihrer Aktivitäten</p>
                      </div>
                      <mat-slide-toggle formControlName="weeklySummary" color="primary"></mat-slide-toggle>
                    </div>
                  </div>
                </div>

                <!-- Display Settings -->
                <div class="bg-white border border-gray-200 rounded-lg p-6">
                  <h3 class="text-lg font-semibold text-gray-900 mb-4">Anzeige</h3>
                  <div class="space-y-4">
                    <div class="flex items-center justify-between">
                      <div>
                        <h4 class="text-sm font-medium text-gray-900">Dunkles Design</h4>
                        <p class="text-sm text-gray-500">Verwenden Sie das dunkle Design für bessere Sichtbarkeit</p>
                      </div>
                      <mat-slide-toggle formControlName="darkMode" color="primary"></mat-slide-toggle>
                    </div>

                    <div class="flex items-center justify-between">
                      <div>
                        <h4 class="text-sm font-medium text-gray-900">Kompakte Ansicht</h4>
                        <p class="text-sm text-gray-500">Zeigen Sie mehr Inhalte auf dem Bildschirm an</p>
                      </div>
                      <mat-slide-toggle formControlName="compactView" color="primary"></mat-slide-toggle>
                    </div>

                    <div class="form-group">
                      <label class="form-label" for="language">Sprache</label>
                      <select
                        class="form-control"
                        id="language"
                        formControlName="language"
                        class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-64 p-2.5">
                        <option value="de">Deutsch</option>
                        <option value="en">English</option>
                        <option value="fr">Français</option>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- Privacy Settings -->
                <div class="bg-white border border-gray-200 rounded-lg p-6">
                  <h3 class="text-lg font-semibold text-gray-900 mb-4">Datenschutz</h3>
                  <div class="space-y-4">
                    <div class="flex items-center justify-between">
                      <div>
                        <h4 class="text-sm font-medium text-gray-900">Analytics aktivieren</h4>
                        <p class="text-sm text-gray-500">Helfen Sie uns, die Anwendung zu verbessern</p>
                      </div>
                      <mat-slide-toggle formControlName="analytics" color="primary"></mat-slide-toggle>
                    </div>

                    <div class="flex items-center justify-between">
                      <div>
                        <h4 class="text-sm font-medium text-gray-900">Cookies akzeptieren</h4>
                        <p class="text-sm text-gray-500">Erlauben Sie die Verwendung von Cookies für bessere Funktionalität</p>
                      </div>
                      <mat-slide-toggle formControlName="cookies" color="primary"></mat-slide-toggle>
                    </div>
                  </div>
                </div>

                <!-- System Settings -->
                <div class="bg-white border border-gray-200 rounded-lg p-6">
                  <h3 class="text-lg font-semibold text-gray-900 mb-4">System</h3>
                  <div class="space-y-4">
                    <div class="form-group">
                      <label class="form-label" for="sessionTimeout">Session-Timeout (Minuten)</label>
                      <input
                        type="number"
                        class="form-control"
                        id="sessionTimeout"
                        formControlName="sessionTimeout"
                        placeholder="30"
                        min="5"
                        max="480"
                        class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-64 p-2.5" />
                      <div class="text-gray-500 text-sm mt-1">5-480 Minuten</div>
                    </div>

                    <div class="flex items-center justify-between">
                      <div>
                        <h4 class="text-sm font-medium text-gray-900">Auto-Save aktivieren</h4>
                        <p class="text-sm text-gray-500">Speichern Sie Änderungen automatisch</p>
                      </div>
                      <mat-slide-toggle formControlName="autoSave" color="primary"></mat-slide-toggle>
                    </div>
                  </div>
                </div>

                <!-- Save Button -->
                <div class="form-group pt-6 border-t border-gray-200">
                  <button
                    type="submit"
                    class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg flex items-center">
                    <mat-icon class="mr-2">save</mat-icon>
                    Einstellungen speichern
                  </button>
                </div>
              </form>
              </div>
            </div>
          </mat-tab>

      </mat-tab-group>
    </div>

    <!-- Footer (aligned with client component) -->
    <div class="mt-6 pt-4 border-t border-gray-200 flex justify-end space-x-2">
      <button mat-button type="button">
        Abbrechen
      </button>
      <button mat-raised-button color="primary" type="button" (click)="saveGeneralSettings()">
        <mat-icon class="mr-2">save</mat-icon>
        Speichern
      </button>
    </div>
  </div>
</div>
